exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-32f036dc]{font-weight:400!important}input[data-v-32f036dc]::-webkit-inner-spin-button,input[data-v-32f036dc]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-32f036dc]{-moz-appearance:textfield}.table-middle>table>tbody>tr>td[data-v-32f036dc],.table-middle>table>thead>tr>th[data-v-32f036dc]{vertical-align:middle}", ""]);

// exports
